import { Button, Stack, Typography } from "@mui/material";
import OutstandingCredits from "./OutstandingCredits";
import { Link } from "react-router-dom";
import ConfettiExplosion from "react-confetti-explosion";
import DpcSessions from "./DpcSessions";
import Rewards from "./RewardsCarousel";
import useProduct from "../utils/useProduct";
import DpcCarousel from "./DpcCarousel";
import useCart from "../utils/useCart";
import { useEffect } from "react";
import Timeline from "./Timeline";

export default function DpcDouble(){

    const { setCart } = useCart()

    const product = useProduct()

    useEffect(() => {

        window.localStorage.removeItem('nextCourseId');

        setCart({ dpcStep: 1 })

    }, [setCart])

    return (

        <Stack spacing={4} sx={{maxWidth: 800, margin: 'auto'}}>

            <Stack alignItems="center">
                <ConfettiExplosion />
            </Stack>

            <Timeline step={1} />

            <OutstandingCredits />


            <Stack spacing={1}>

                <Typography variant="h5">
                    <b>Étape 1 :</b> sélectionnez votre deuxième formation 100% prise en charge DPC
                </Typography>

                <Typography variant="body2" color="text.secondary">
                    (sous réserve de vos crédits DPC disponibles)
                </Typography>

            </Stack>


            <DpcCarousel />


            <DpcSessions />


            <Typography variant="h5">
                <b>Étape 2 :</b> sélectionnez votre cadeau
            </Typography>


            <Rewards />


            <Stack direction="row" justifyContent="flex-end" spacing={2}>

                <Button 
                    variant="outlined" 
                    component={Link} 
                    to="/"
                    size="large"
                >
                    Je ne suis pas intéressé(e)
                </Button>
                
                {product && 

                    <Button 
                        variant="contained" 
                        component={Link} 
                        to={`/courses/${product.reference}/dpc/${product.reference2}`}
                        size="large"
                    >
                        Continuer
                    </Button>
                }

            </Stack>

        </Stack>
    );
}

